import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { 
  faUser, faCalendarAlt, faFlag, faExclamationCircle, 
  faSignOutAlt, faUserCircle, faEye, faCalendarPlus, 
  faFlagCheckered, faBinoculars, faCompass, faMapMarkedAlt, 
  faTrophy, faTimes, faEdit, faPlus, faGlobe, 
  faExclamationTriangle, faSync, faCalendar, faChevronRight,
  faMapMarkerAlt, faSearch, faSignal, faArrowLeft, faTrash,
  faCalendarCheck, faShip, faPlusCircle, faCheckCircle, faCheck,
  faClock, faInfoCircle, faMap, faUsers, faRoute, faSave,
  faAdjust, faWind, faCog, faLocationArrow, faList, faPlay,
  faMapMarker, faPause, faSpinner, faHistory, faHourglass,
  faExpand, faHome, faBullhorn, faRedo, faCompress, faEyeSlash,
  faStop, faSignInAlt, faUserCheck, faAnchor, faHandPointer,
  faDraftingCompass, faBroadcastTower, faTachometerAlt, faClone,
  faArrowUp, faUserPlus, faPhone, faImage, faShieldAlt, faMedal,
  faBuilding, faArrowsAlt, faArrowRight, faArrowDown, faLock,
  faTable, faDownload, faUpload, faStar, faTag, faForward,
  faChevronDown, faChevronUp, faStopCircle, faPlayCircle, faFilter,
  faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight, faThLarge
} from '@fortawesome/free-solid-svg-icons';
import { 
  faStar as faStarRegular 
} from '@fortawesome/free-regular-svg-icons';

// Add all used icons to the library
library.add(
  faUser, faCalendarAlt, faFlag, faExclamationCircle, 
  faSignOutAlt, faUserCircle, faEye, faCalendarPlus, 
  faFlagCheckered, faBinoculars, faCompass, faMapMarkedAlt,
  faTrophy, faTimes, faEdit, faPlus, faGlobe,
  faExclamationTriangle, faSync, faCalendar, faChevronRight,
  faMapMarkerAlt, faSearch, faSignal, faArrowLeft, faTrash,
  faCalendarCheck, faShip, faPlusCircle, faCheckCircle, faCheck,
  faClock, faInfoCircle, faMap, faUsers, faRoute, faSave,
  faAdjust, faWind, faCog, faLocationArrow, faList, faPlay,
  faMapMarker, faPause, faSpinner, faHistory, faHourglass,
  faExpand, faHome, faBullhorn, faRedo, faCompress, faEyeSlash,
  faStop, faSignInAlt, faUserCheck, faAnchor, faHandPointer,
  faDraftingCompass, faBroadcastTower, faTachometerAlt, faClone,
  faArrowUp, faUserPlus, faPhone, faImage, faShieldAlt, faMedal,
  faBuilding, faArrowsAlt, faArrowRight, faArrowDown, faLock,
  faTable, faDownload, faUpload, faStar, faStarRegular, faTag, faForward,
  faChevronDown, faChevronUp, faStopCircle, faPlayCircle, faFilter,
  faAngleDoubleLeft, faAngleLeft, faAngleRight, faAngleDoubleRight, faThLarge
);

const TabBarIcon = ({ name, color = 'currentColor', size = 'normal', spin = false }) => {
  const sizeMap = {
    small: 'sm',
    normal: '1x',
    large: '2x',
    '2x': '2x',
    '3x': '3x'
  };

  // Map string names to icon constants
  const iconMap = {
    'user': faUser,
    'calendar-alt': faCalendarAlt,
    'flag': faFlag,
    'exclamation-circle': faExclamationCircle,
    'sign-out-alt': faSignOutAlt,
    'user-circle': faUserCircle,
    'eye': faEye,
    'calendar-plus': faCalendarPlus,
    'flag-checkered': faFlagCheckered,
    'binoculars': faBinoculars,
    'compass': faCompass,
    'map-marked-alt': faMapMarkedAlt,
    'trophy': faTrophy,
    'times': faTimes,
    'edit': faEdit,
    'plus': faPlus,
    'globe': faGlobe,
    'exclamation-triangle': faExclamationTriangle,
    'sync': faSync,
    'calendar': faCalendar,
    'chevron-right': faChevronRight,
    'map-marker-alt': faMapMarkerAlt,
    'search': faSearch,
    'signal': faSignal,
    'arrow-left': faArrowLeft,
    'trash': faTrash,
    'calendar-check': faCalendarCheck,
    'ship': faShip,
    'plus-circle': faPlusCircle,
    'check-circle': faCheckCircle,
    'check': faCheck,
    'clock': faClock,
    'info-circle': faInfoCircle,
    'map': faMap,
    'users': faUsers,
    'route': faRoute,
    'save': faSave,
    'adjust': faAdjust,
    'wind': faWind,
    'cog': faCog,
    'location-arrow': faLocationArrow,
    'list': faList,
    'play': faPlay,
    'map-marker': faMapMarker,
    'pause': faPause,
    'spinner': faSpinner,
    'history': faHistory,
    'hourglass': faHourglass,
    'expand': faExpand,
    'home': faHome,
    'bullhorn': faBullhorn,
    'redo': faRedo,
    'compress': faCompress,
    'eye-slash': faEyeSlash,
    'stop': faStop,
    'sign-in-alt': faSignInAlt,
    'user-check': faUserCheck,
    'anchor': faAnchor,
    'hand-pointer': faHandPointer,
    'drafting-compass': faDraftingCompass,
    'broadcast-tower': faBroadcastTower,
    'tachometer-alt': faTachometerAlt,
    'clone': faClone,
    'arrow-up': faArrowUp,
    'user-plus': faUserPlus,
    'phone': faPhone,
    'image': faImage,
    'shield-alt': faShieldAlt,
    'medal': faMedal,
    'building': faBuilding,
    'arrows-alt': faArrowsAlt,
    'arrow-right': faArrowRight,
    'arrow-down': faArrowDown,
    'lock': faLock,
    'table': faTable,
    'download': faDownload,
    'upload': faUpload,
    'star': faStar,
    'star-regular': faStarRegular,
    'tag': faTag,
    'forward': faForward,
    'chevron-down': faChevronDown,
    'chevron-up': faChevronUp,
    'stop-circle': faStopCircle,
    'play-circle': faPlayCircle,
    'filter': faFilter,
    'angle-double-left': faAngleDoubleLeft,
    'angle-left': faAngleLeft,
    'angle-right': faAngleRight,
    'angle-double-right': faAngleDoubleRight,
    'th-large': faThLarge,
    'refresh': faSync // Map refresh to sync icon
  };

  const icon = iconMap[name] || name;

  return <FontAwesomeIcon icon={icon} color={color} size={sizeMap[size] || size} spin={spin} />;
};

export default TabBarIcon;